// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal-module__backdrop___2lr_H","modal":"Modal-module__modal___1itJF"};